<style lang="scss" scoped>
.blue {
  background: red !important;
}
</style>
<template>
  <section class="content">
    <h4>管理</h4>
    
    <el-table
      v-loading="loading"
      :data="list"
      style="width: 100%; margin-top: 10px"
      height="50vh"
    >
      <el-table-column align="center" prop="name" label="赛事主办方" />
      <el-table-column align="center" prop="im_group_num" label="群号" />
      <el-table-column v-if="this.userinfo.id == 1" align="center" prop="sys_user_id" label="用户id" />
      <el-table-column v-if="this.userinfo.id == 1" align="center" prop="priority" label="排序" />
      
      <el-table-column align="center" prop="date" label="操作" width="150">
        <template slot-scope="scope">
          <el-button @click="edit(scope.row)" size="mini" type="warning"
            >编辑</el-button
          >
          <el-button @click="del(scope.row)" size="mini" type="danger"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Page
      ref="pageButton"
      :current="form.page"
      :page_size="form.page_size"
      :total="total"
      @pageChange="gopage"
    />
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="比赛方名称" prop="name">
          <el-input
            clearable
            v-model="form.name"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="简介">
          <el-input type="textarea" v-model="form.intro"></el-input>
        </el-form-item>
    
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="open = false">取 消</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import Page from "../../components/Page";
import { FullCalendar } from "vue-fullcalendar";
export default {
  components: {
    Page,
    "full-calendar": require("vue-fullcalendar"),
  },
  data() {
    return {
      monthData: [],
      loading: false,
      queryParams: {
        page: 1,
        sys_user_id:0,
      },
      form: {monthData:[]},
      list: [{}, {}],
      total: 0,
      title: "新增比赛方",
      open: false,
      rules: {
        name: [{ required: true, message: "请输入比赛名称", trigger: "blur" }],
        intro: [
          { required: true, message: "请输入开始时间", trigger: "blur" },
        ],
        
      },
      userinfo:{},
      
    };
  },
  methods: {
    del(row) {
      this.$confirm("确定删除吗?", "提示", {
        type: "warning",
      }).then(() => {
        this.$api.delSuperMatch({ id: row.id,sys_user_id:row.sys_user_id }).then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getData();
        });
      });
    },
    edit(row) {
      this.$router.push({
          path: "/addSuperMatch",
          query: {
            id: row.id,
            sys_user_id:row.sys_user_id,
          }
        });
      
    },
    gopage(size) {
      if (size) {
        this.queryParams.page_size = size;
      }
      this.queryParams.page = this.$refs.pageButton.page;
      this.getData();
    },

    getUserInfo() {
      this.$api.getAccountInfo().then(res=>{
				if(!res.code){
					this.userinfo = res.data.data
					this.getData();
				}
			})
    },
    getData() {
      this.loading = true;
      this.queryParams.sys_user_id = this.userinfo.id
      this.$api.getSuperMatchList(this.queryParams).then((res) => {
        this.list = res.data.data.list;
        this.total = res.data.data.total;
        this.loading = false;
        console.log(this.list);
      });
    },
    handleAdd() {
      this.$router.push({
          path: "/addSuperMatch"
        });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
        }
      });
    },
    
    
  },
  created() {
    this.getUserInfo();
  },
};
</script>